import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tab_menu" }
const _hoisted_2 = { class: "tab_menu_lst" }
const _hoisted_3 = { class: "blind" }
const _hoisted_4 = {
  ref: "hashtagWrapper",
  class: "item_filter_lst"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("ul", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
        return (_openBlock(), _createBlock("li", {
          key: index,
          class: ["menu", _ctx.selected(link)]
        }, [
          _createVNode(_component_router_link, {
            to: link.routing,
            class: "menu_link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(link.text), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ], 2))
      }), 128))
    ]),
    (_ctx.isProductListPage())
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["depth2", {is_open: _ctx.isExpandedHashtag}]
        }, [
          _withDirectives(_createVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleExpandButton && _ctx.toggleExpandButton(...args))),
            class: "btn_fold"
          }, [
            _createVNode("span", _hoisted_3, _toDisplayString(_ctx.expandButtonHelp), 1)
          ], 512), [
            [_vShow, _ctx.renderExpandButton || _ctx.isExpandedHashtag]
          ]),
          _createVNode("ul", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hashtagList, (hashtag, index) => {
              return (_openBlock(), _createBlock("li", {
                key: index,
                class: ["item", {is_sel: hashtag.isSelected}]
              }, [
                _createVNode("button", {
                  type: "button",
                  class: "item_txt",
                  onClick: ($event: any) => (_ctx.selectHashtag(hashtag, index))
                }, _toDisplayString(hashtag.name), 9, ["onClick"])
              ], 2))
            }), 128))
          ], 512)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}